module.exports = __webpack_public_path__ + "img/dp-dy-sh8.8253a5b2.png";